import {OpeningHoursForDayRestDto} from "@/api/pharma-cms-pharmacy/models";

export class OpeningHoursForDayRestDtoModel implements OpeningHoursForDayRestDto {
    // Nullable to match the generated interface: the API returns null for an unused slot, and
    // closing a day clears the times by setting them to null rather than dropping them.
    hours1_from?: string | null;
    hours1_till?: string | null;
    hours2_from?: string | null;
    hours2_till?: string | null;
    hours3_from?: string | null;
    hours3_till?: string | null;
    open: boolean;

    constructor(open: boolean) {
        this.open = open;
    }

    public static createWithDefaults(): OpeningHoursForDayRestDtoModel {
        const model = new OpeningHoursForDayRestDtoModel(false);

        model.hours1_from = '';
        model.hours1_till = '';
        model.hours2_from = '';
        model.hours2_till = '';
        model.hours3_from = '';
        model.hours3_till = '';

        return model;
    }
}
